import { isRouteErrorResponse, useRouteError } from "react-router-dom";
import { ErrorPage } from "@components/feedback/ErrorPage";

export function RouteErrorPage() {
  const error = useRouteError();
  const kind = isRouteErrorResponse(error)
    ? error.status === 404
      ? "not-found"
      : error.status === 403
        ? "forbidden"
        : "unexpected"
    : "unexpected";
  return <ErrorPage kind={kind} />;
}
